import React from "react";
import { useParams } from "react-router-dom"; // Import useParams
import MasterLayout from "../masterLayout/MasterLayout";
import ComplainFormPageStatusUpdate from "../components/ComplainFormPageStatusUpdate";

// Opens a Probe Case on the same close/update page used by the Closed list, but
// returns to /probe/list after Re-Open / Resolve (via the listPath prop).
const ComplainFormProbeUpdate = () => {
  const { id } = useParams(); // Get the id from the URL parameters

  return (
    <div>
      <MasterLayout>
        <ComplainFormPageStatusUpdate complainId={id} probeMode />
      </MasterLayout>
    </div>
  );
};

export default ComplainFormProbeUpdate;
